import CardCommon from '@/pages/opinion/components/CardCommon';
import KeywordBox from '@/pages/opinion/pages/feeds/components/KeywordBox';
import { getFeedsKeyword, getFeedsStats } from '@/pages/opinion/services';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'tea-component';
import { StatsDetailType, keywordStatsDetailType } from '../..';
export default function StatsDetailKeyword({
  gameInfo,
  userInfo,
  setSelectRenderKeyword,
  filter,
  statsDetailType,
  selectKeyword,
  setSelectKeyword,
  statsDetailChartsData,
  tableTotal = 0,
  handleStatsData,
  backCommentTotal = () => {},
  commentLoading = false,
  needBrandHealth = false,
}: {
  gameInfo: any;
  userInfo: any;
  setSelectRenderKeyword: any;
  tableTotal: number;
  filter: any;
  statsDetailType: StatsDetailType;
  selectKeyword: any;
  setSelectKeyword: any;
  statsDetailChartsData: any;
  backCommentTotal: (value: number) => void;
  handleStatsData?: any;
  commentLoading?: boolean;
  needBrandHealth?: boolean;
}) {
  const [feedsKeyword, setFeedsKeyword] = useState<any>([]);
  const [feedsStats, setFeedsStats] = useState<any>({});

  const [feedsKeywordLoading, setFeedsKeywordLoading] = useState<boolean>(true);
  const [feedsStatsLoading, setFeedsStatsLoading] = useState<boolean>(true);

  const fetchKeyword = async (params: any) => {
    setFeedsKeywordLoading(true);
    const keyword = await getFeedsKeyword({ ...params });
    setFeedsKeyword(keyword);
    setFeedsKeywordLoading(false);
  };
  const fetchStats = async (params: any, updateCommentTotal = true) => {
    if (updateCommentTotal) {
      const stats = await getFeedsStats({ ...params });
      handleStatsData?.(stats);
      backCommentTotal(stats?.total || 0);
    } else {
      setFeedsStatsLoading(true);
      const stats = await getFeedsStats({ ...params });
      backCommentTotal(stats?.total || 0);
      handleStatsData?.(stats);
      setFeedsStats(stats);
      setFeedsStatsLoading(false);
    }
  };

  const fetchData = (updateCommentTotal = false) => {
    const params = {
      ...gameInfo,
      ...filter,
      user_id: userInfo.userid,
      review_type: 'all',
      translated_to: 'origin',
      statistics_field: statsDetailChartsData?.dataType || 'keyword',
      channel_type: '',
    };

    if (updateCommentTotal) {
      params.keyword = selectKeyword;
    }

    if (statsDetailChartsData?.dataType === 'region') {
      params.region_type = statsDetailChartsData?.regionType;
    }

    !updateCommentTotal && fetchKeyword({ ...params });
    fetchStats({ ...params }, updateCommentTotal);
  };

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;

    fetchData();
  }, [userInfo, gameInfo, filter]);

  useEffect(() => {
    if (!userInfo || !gameInfo || !filter) return;

    fetchData(true);
  }, [selectKeyword]);

  return (
    <Row className="details-card">
      <Col>
        <CardCommon
          loadingHeight={220}
          loading={feedsKeywordLoading || feedsStatsLoading}
        >
          <KeywordBox
            keywords={feedsKeyword}
            data={feedsStats}
            needBrandHealth={needBrandHealth}
            tableTotal={tableTotal}
            commentLoading={commentLoading}
            stabled={
              keywordStatsDetailType.includes(statsDetailType) ||
              statsDetailChartsData?.dataType === 'keyword'
                ? true
                : false
            }
            autoSelectFirst={
              keywordStatsDetailType.includes(statsDetailType) ||
              statsDetailChartsData?.dataType === 'keyword'
                ? true
                : false
            }
            keywordChange={({ children, keywordRender }) => {
              setSelectKeyword([...children]);
              setSelectRenderKeyword({
                origin: keywordRender?.keyword,
                zh: keywordRender?.keyword_cn,
                en: keywordRender?.keyword_en,
              });
            }}
          />
        </CardCommon>
      </Col>
    </Row>
  );
}
